import React from 'react';
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

export default function WD_curriculum_page() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className={classes.root}>
      <Accordion className='py-2' expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography className='fs-5'>1. INTRODUCTION</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Intro to web Development & Webpage.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography className='fs-5'>2. How internet works</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Browsing the Web, Domain & IP Address. 
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <Typography className='fs-5'>3. HTML</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          HTML:
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className='fs-5'>4. CSS</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Introduction, syntax,inline, internal & external, box model
            <br></br>CSS3, selectors, background, text, images.BG images, animations, CSS grid & CSS layout , basic html tags,intermediate & advanced html tags.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel5bh-content"
          id="panel5bh-header"
        >
          <Typography className='fs-5'>5. Boot strap & SAAS</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Introduction to boot starp, installation & grid system, Forms button Icons integration Introduction to Saas and installation & variable nesting Creating a portfolio with webpage with header & footer 
            Webpage with hero section & animations & responsive.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel6bh-content"
          id="panel6bh-header"
        >
          <Typography className='fs-5'>6. Javascript</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Introduction, number, string, Boolean comparison, variables, exercise: make a calculator.control flow, functions, arrays, objects, loops, keywords, section outline documents.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel7'} onChange={handleChange('panel7')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel7bh-content"
          id="panel7bh-header"
        >
          <Typography className='fs-5'>7. jQuery & NODE.JS</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Basics, selectors, traversing, CSS, Events, ajax, DOM Introduction to Node js, modules, ES6 Modules, types of modules Building a server & Restful ApI’S Middleware functions & express framework.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel8'} onChange={handleChange('panel8')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel8bh-content"
          id="panel8bh-header"
        >
          <Typography className='fs-5'>8. Database & SQL</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Introduction to database & SQL, Create table, joining tables, delete & drop, Installing & using postre sql, SQL : insert, select, alter, update, conditional selection, function.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel9'} onChange={handleChange('panel9')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel9bh-content"
          id="panel9bh-header"
        >
          <Typography className='fs-5'>9. DOM Manipulation</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Introduction, Dom selectors, Events, background generator & background generator files.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel10'} onChange={handleChange('panel10')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel10bh-content"
          id="panel10bh-header"
        >
          <Typography className='fs-5'>10. OOPS</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Inheritance, constructors, destructors & encapsulation.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel11'} onChange={handleChange('panel11')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel11bh-content"
          id="panel11bh-header"
        >
          <Typography className='fs-5'>11. Understanding concepts overviews</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            REACT JS, ANGULAR, Springboot with my SQL Mongo DB & node js.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel12'} onChange={handleChange('panel12')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel12bh-content"
          id="panel12bh-header"
        >
          <Typography className='fs-5'>12. MINOR & MAJOR PROJECT</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Minor Project, Major Project, Project overview.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
